import { storeActions } from '@/store/actions'
import { AssistantFeedItem } from '@/store/assistant'
import { useStoreDispatch } from '@/store/hooks'
import { Button, ButtonVariant } from '@repo/ui/button'
import { useT } from '@repo/ui/hooks'
import { ComponentType, memo, SVGProps } from 'react'

type CtaGenericProps = {
  buttonVariant?: ButtonVariant
  ctaItemAfterClick: 'replace' | 'remove' | 'keep'
  ctaTranskey: string
  icon?: ComponentType<SVGProps<SVGSVGElement>>
  isDisabled: boolean
  itemIndex: number
  onClick: () => void
} & (
  | {
      ctaItemAfterClick: 'replace'
      newItem: AssistantFeedItem
    }
  | {
      ctaItemAfterClick: 'remove' | 'keep'
      newItem?: never
    }
)

export const CtaGeneric = memo(function ({
  buttonVariant = 'highlight',
  ctaItemAfterClick,
  ctaTranskey,
  icon: Icon,
  isDisabled,
  itemIndex,
  newItem,
  onClick,
}: CtaGenericProps) {
  const dispatch = useStoreDispatch()
  const { t } = useT({ keyPrefix: 'assistant' })

  const handleClick = () => {
    if (ctaItemAfterClick === 'remove') {
      dispatch(storeActions.assistant.remove.feed.item({ itemIndex }))
    } else if (ctaItemAfterClick === 'replace') {
      dispatch(
        storeActions.assistant.replace.feed.item({
          itemIndex,
          newItem,
        }),
      )
    }
    onClick()
  }

  return (
    <Button
      type="button"
      variant={buttonVariant}
      className="shadow-primary-600/50 w-fit shadow-md"
      disabled={isDisabled}
      onClick={handleClick}
    >
      {Icon && <Icon className="size-4" />}
      {t(ctaTranskey)}
    </Button>
  )
})
